module.exports = __webpack_public_path__ + "static/media/42-10.27210ce8.mp3";